import React from 'react';
import { Reveal } from './Reveal';
import { CHECKOUT_URL } from '../data/content';
export function FinalCta() {
  return <section className="bg-grass px-5 py-20 text-white sm:py-24 lg:px-8" data-id="element-97" data-mp="vghhtqhxufpj">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="19fgxw9rdxma3">
        <h2 className="display text-4xl sm:text-6xl" data-id="element-99" data-mp="19cuoe4kxowp8">Tomá el mando de tu equipo</h2>
        <p className="mx-auto mt-5 max-w-xl text-lg font-medium text-white/85" data-id="element-100" data-mp="15c2d75si4hqb">
          El próximo entrenamiento es esta semana. Podés volver a improvisar, o entrar
          con el plan escrito.
        </p>
        <div className="mt-9 flex flex-col items-center gap-4" data-id="element-101" data-mp="1ebxvrvodzf0d">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center rounded-md bg-ink px-8 py-5 text-lg font-extrabold uppercase tracking-tight text-white shadow-[0_8px_0_0_rgba(0,0,0,0.35)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-ink-soft active:translate-y-1 active:shadow-[0_3px_0_0_rgba(0,0,0,0.35)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink sm:text-2xl" data-id="element-102" data-mp="1t1wsdu0amidq">
            Descargar el pack completo — $24.999
          </a>
          <p className="text-sm font-semibold uppercase tracking-wide text-white/80" data-id="element-103" data-mp="122lo0ivsnda2">
            Mercado Pago · acceso inmediato vía mail · 7 días de garantía
          </p>
        </div>
      </Reveal>
    </section>;
}